import React from 'react'
import Footer from './Footer'
import Carousal from './Carousal'
import Section from '../pages/Section'
import Treatment from '../pages/Treatment'
import AyushmanTPASection from '../pages/AyushmanTPASection'

const Layout = () => {
  return (
    <div>

      <Carousal />
      {/* <AyushmanTPASection/> */}
      <Section />

      <Treatment />




      <Footer />
    </div>
  )
}

export default Layout